import {ResearchKeywordDTO} from '../dto/research-keywords';


export enum QueryBlockOperator {
  AND = 'AND',
  OR = 'OR',
}

export enum QueryBlockFilter {
  None = 'None',
  All = 'All Fields',
  MESH = 'MeSH',
  TITLE_ABSTRACT = 'Title/Abstract',
}

export class QueryBlockItem {
  uId: string;
  children: QueryBlockItem[];
  operator: QueryBlockOperator;
  keyword?: ResearchKeywordDTO;
  filter?: QueryBlockFilter;

  constructor(options?: {
    children?: QueryBlockItem[]
    operator?: QueryBlockOperator;
    keyword?: ResearchKeywordDTO;
    filter?: QueryBlockFilter;
  }) {
    this.children = [];
    this.operator = QueryBlockOperator.AND;
    if (options) {
      this.children = options.children || [];
      this.keyword = options.keyword;
      this.filter = options.filter;
      this.operator = options.operator || QueryBlockOperator.AND;
    }
    this.uId = '_' + Math.random().toString(36).substring(2, 11);
  }
}
